import { render, staticRenderFns } from "./distributionList.vue?vue&type=template&id=000906ee&scoped=true"
import script from "./distributionList.vue?vue&type=script&lang=js"
export * from "./distributionList.vue?vue&type=script&lang=js"
import style0 from "./distributionList.vue?vue&type=style&index=0&id=000906ee&prod&lang=less&scoped=true"
import style1 from "./distributionList.vue?vue&type=style&index=1&id=000906ee&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "000906ee",
  null
  
)

export default component.exports